import { defineQuery } from '@rocicorp/zero';
import * as z from 'zod';
import { Status, zql } from '../schema.js';
import { applyCursor } from '../util/apply-cursor.js';
import { Cursor, Sort } from './util.js';
export const CustomersFilters = z.object({
    name: z.string().optional(),
    status: z.array(Status).optional(),
});
export const ListCustomersInput = z.object({
    cursor: Cursor.extend({
        createdAt: z.number(),
        name: z.string(),
    }).optional(),
    sort: Sort.extend({
        field: z.enum(['createdAt', 'name']).default('createdAt'),
    }),
    limit: z.number().optional(),
    filters: CustomersFilters.optional(),
});
export const customerQueries = {
    listCustomers: defineQuery(ListCustomersInput, params => {
        const input = params.args;
        let q = zql.customers.where('deletedAt', 'IS', null);
        if (input.filters?.name?.trim()) {
            const searchTerm = `%${input.filters.name.trim()}%`;
            q = q.where(({ cmp }) => cmp('name', 'ILIKE', searchTerm));
        }
        q = applyCursor(q, { cursor: input.cursor, sort: input.sort, limit: input.limit });
        return q;
    }),
    getCustomerById: defineQuery(z.string(), ({ args }) => {
        return zql.customers
            .related('pharmacy')
            .related('created')
            .related('address')
            .related('deliveryAddress')
            .where('id', '=', args)
            .where('deletedAt', 'IS', null)
            .one();
    }),
    getCustomerActivitiesById: defineQuery(z.string(), ({ args }) => {
        return zql.eventLogs
            .related('actor')
            .where('resource', '=', 'customer')
            .where('resourceId', '=', args)
            .orderBy('performedAt', 'desc');
    }),
};
//# sourceMappingURL=customers.queries.js.map